// extracted by mini-css-extract-plugin
export default {"links":"ProjectsItemPage_links__jo5mZ","tag-block":"ProjectsItemPage_tag-block__s-zv5"};